/**
 * @generated SignedSource<<e5878f2a4cd1688d9d8f7dfe2713dd4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SendPasswordResetEmailInput = {
  email: string;
};
export type useSendPasswordResetRequestMutation$variables = {
  input: SendPasswordResetEmailInput;
};
export type useSendPasswordResetRequestMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly success: boolean;
  } | null | undefined;
};
export type useSendPasswordResetRequestMutation = {
  response: useSendPasswordResetRequestMutation$data;
  variables: useSendPasswordResetRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSendPasswordResetRequestMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "SendPasswordResetEmailPayload",
        "kind": "LinkedField",
        "name": "sendPasswordResetEmail",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSendPasswordResetRequestMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "SendPasswordResetEmailPayload",
        "kind": "LinkedField",
        "name": "sendPasswordResetEmail",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2b90db70e5229608dceb7c23a18717f2",
    "id": null,
    "metadata": {},
    "name": "useSendPasswordResetRequestMutation",
    "operationKind": "mutation",
    "text": "mutation useSendPasswordResetRequestMutation(\n  $input: SendPasswordResetEmailInput!\n) {\n  responsePayload: sendPasswordResetEmail(input: $input) {\n    success\n    errors {\n      __typename\n      code\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c8b8298fcfcf7e7765494e7d921695f4";

export default node;
